<template>
  <div class="page-con">
    <div class="header">
      <div>
        <img class="logo-left" @click="toggleFullScreen" src="https://cdn.spbcn.org/ITSO_WEB/screen2015/left_1.png" alt="">
        <!-- <img class="logo-left2" @click="toggleFullScreen" src="https://cdn.spbcn.org/ITSO_WEB/screen2015/right.png" alt=""> -->
      </div>
      <div class="title">
        <div class="cn">小组积分赛抽签【{{ level.cn }}】</div>
        <div class="en">Drawing Lots for Group Points Competition of {{ level.en }}</div>
      </div>
      <img class="logo-right" @click="refresh" src="https://cdn.spbcn.org/ITSO_WEB/20160515/center_1.png" alt="">
    </div>
    <div class="content-scroll">
      <div class="flex">
        <div class="group" v-for="(group, i) in groupList" :key="i">
          <div class="index">GROUP <span>{{ group.group }}</span></div>
          <div class="item" :style="{'height': itemHeight + 'px'}" v-for="(item, j) in group.teamList" :key="j">
            <span class="j">{{ j+1 }}</span>
            <img class="ava" v-if="item.str" :src="formatImg(item.str)" alt="">
            <div class="team" v-if="item.str">
              <div class="team-name">{{ formatTeamName(item.str) }}</div>
              <div class="school-name">{{ formatSchoolName(item.str) }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="team-list" v-if="teamList.length">
        <span class="t">待抽签战队（{{ teamList.length }}）：</span>
        <span v-for="(item, i) in teamList" :key="i">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      level: {},
      levels: [
        { cn: '小学组', en: 'Primary School Group' },
        { cn: '初中组', en: 'Middle School Group' },
        { cn: '高中组', en: 'High School Group' }
      ],
      groupList: [],
      teamList: [],
      queryForm: {
        activityType: this.$chnEngStatusCode.itsoActivityType,
        level: '',
        raceSchedule: '',
        season: ''
      },
      timer: null,
      itemHeight: 0 // 3-200 4-160 5-130
    }
  },
  created () {
    this.refresh()
    this.interval()
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    interval () {
      this.timer = setInterval(() => {
        this.refresh()
      }, 2000)
    },
    refresh () {
      this.$http.get('common/itsoDrawLots/getLargeScreenFormInfo').then(res => {
        if (res.code === 200) {
          if (res.data) {
            this.groupList = JSON.parse(res.data.formText)
            this.level = this.levels[res.data.level]
            this.queryForm.level = res.data.level
            this.queryForm.raceSchedule = res.data.raceSchedule
            this.queryForm.season = res.data.season
            this.getTeamList()
            const teamNum = res.data.teamNum
            this.itemHeight = teamNum === 3 ? 160 : teamNum === 4 ? 124 : teamNum === 5 ? 120 : 130
          } else {
            this.groupList = []
            this.teamList = []
          }
        }
      })
    },
    getTeamList () {
      this.$http.get('common/itsoDrawLots/getTeamList', { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          this.teamList = res.data
          this.refreshData()
        }
      })
    },
    refreshData (teamList) {
      // 处理数组内数据
      this.groupList.forEach(group => {
        group.teamList.forEach(item => {
          this.teamList = this.teamList.filter(teamItem => teamItem.name !== item.str.split('\n')[0])
        })
      })
    },
    formatTeamName (str) {
      return str.split('\n')[0]
    },
    formatSchoolName (str) {
      return str.split('\n')[1]
    },
    formatImg (str) {
      return str.split('\n')[2]
    },
    toggleFullScreen () {
      if (!document.fullscreenElement) {
        this.enterFullScreen()
      } else {
        this.exitFullScreen()
      }
    },
    // 全屏
    enterFullScreen () {
      const element = document.documentElement
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) { /* Firefox */
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) { /* IE/Edge */
        element.msRequestFullscreen()
      }
    },
    // 退出全屏
    exitFullScreen () {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen()
      }
    }
  }
}
</script>
<style lang="less" scoped>
:deep(body) {
  margin: 0;
  padding: 0;
  overflow: hidden;
}

:deep(html) {
  height: 100%;
  overflow: hidden;
}

.page-con{
  background: linear-gradient(to bottom, #f29d00, #ec6e21);
  width: 100vw;
  height: 100vh;
  padding: 0 20px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
}
.header{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-top: 154px;
  position: relative;
  flex-shrink: 0;
  .logo-left{
    height: 50px;
    display: block;
    margin-top: 70px;
    position: absolute;
    bottom: 16px;
    z-index: 10;
  }
  .logo-left2{
    height: 40px;
    display: block;
    margin-top: 10px;
    position: relative;
    z-index: 10;
  }
  .logo-right{
    width: 280px;
    position: relative;
    z-index: 10;
  }
  .title{
    text-align: center;
    // padding-top: 78px;
    padding-top: 68px;

    z-index: 0;
    position: absolute;
    left: 0;
    right: 0;
    .cn{
      font-size: 36px;
      font-family: hzgb;
      // font-style: italic;
      color: #000;
    }
    .en{
      margin-top: 10px;
      font-family: hzgb;
      // font-style: italic;
      font-size: 20px;
      color: #000;
    }
  }
}
.content-scroll {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 20px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
}
.flex{
  display: flex;
  justify-content: space-around;
}
.group{
  background-color: #000;
  padding: 0 14px 4px;
  flex: 1;
  min-width: 0; /* 防止内容撑开 */
  max-width: 320px;
  margin: 0 6px;
  .index{
    color: #FFF;
    font-family: hzgb;
    font-size: 16px;
    text-align: center;
    padding: 8px 0;
    span{
      font-size: 24px;
    }
  }
  .item{
    width: 100%;
    height: 130px;
    // background-color: #fab537;
    background-color: #fff;
    margin-bottom: 12px;
    padding: 8px;
    box-sizing: border-box;
    position: relative;
    .j{
      // color: rgba(255, 255, 255, 0.25);
      color: rgba(242, 157, 0, 0.7);
      font-size: 72px;
      font-family: hzgb;
      font-weight: 900;
      font-style: italic;
      position: absolute;
      right: 16px;
      bottom: 0;
    }
    .ava{
      width: 50px;
      height: 50px;
      border-radius: 50px;
      opacity: .75;
      position: absolute;
      left: 16px;
      bottom: 4px;
    }
  }
}
.team{
  position: relative;
  z-index: 10;
  .school-name{
    font-size: 20px;
    font-weight: bold;
    color: #000;
    width: 100%;
  }
  .team-name{
    color: #fff;
    font-size: 18px;
    font-weight: 900;
    background-color: #000;
    padding: 2px 6px;
    display: inline-block;
    margin-bottom: 6px;
  }
}
.team-list{
  margin-top: 20px;
  margin-left: 10px;
  span{
    display: inline-block;
    color: #fff;
    font-size: 18px;
    font-weight: 900;
    background-color: #000;
    padding: 2px 6px;
    display: inline-block;
    margin-bottom: 6px;
    margin-right: 6px;
  }
  .t{
    color: #ec6e21;
  }
}
</style>
